(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blog-index"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const escapeHtml = (value) => {
      return String(value || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
    };

    const buildPageUrl = (pageNumber) => {
      const url = new URL(window.location.href);
      if (pageNumber <= 1) {
        url.searchParams.delete('page');
      } else {
        url.searchParams.set('page', String(pageNumber));
      }
      return `${url.pathname}${url.search}${url.hash}`;
    };

    const renderPagination = (section, pagination, currentPage, totalPages) => {
      if (totalPages <= 1) {
        pagination.hidden = true;
        pagination.innerHTML = '';
        return;
      }

      const parts = [];
      const prevPage = currentPage - 1;
      const nextPage = currentPage + 1;
      const previousLabel = escapeHtml(section.dataset.previousLabel || 'Previous');
      const nextLabel = escapeHtml(section.dataset.nextLabel || 'Next');

      if (currentPage > 1) {
        parts.push(`<a class="ss-blog-index__page-link" href="${buildPageUrl(prevPage)}">${previousLabel}</a>`);
      } else {
        parts.push(`<span class="ss-blog-index__page-link ss-blog-index__page-link--disabled">${previousLabel}</span>`);
      }

      for (let page = 1; page <= totalPages; page += 1) {
        if (page === currentPage) {
          parts.push(`<span class="ss-blog-index__page-link ss-blog-index__page-link--current">${page}</span>`);
        } else {
          parts.push(`<a class="ss-blog-index__page-link" href="${buildPageUrl(page)}">${page}</a>`);
        }
      }

      if (currentPage < totalPages) {
        parts.push(`<a class="ss-blog-index__page-link" href="${buildPageUrl(nextPage)}">${nextLabel}</a>`);
      } else {
        parts.push(`<span class="ss-blog-index__page-link ss-blog-index__page-link--disabled">${nextLabel}</span>`);
      }

      pagination.innerHTML = parts.join('');
      pagination.hidden = false;
    };

    const renderArticles = (section, grid, pagination, cards) => {
      const itemsPerPage = Math.max(parseInt(section.dataset.itemsPerPage || '12', 10), 1);
      const params = new URLSearchParams(window.location.search);
      const requestedPage = Math.max(parseInt(params.get('page') || '1', 10), 1);
      const totalPages = Math.max(Math.ceil(cards.length / itemsPerPage), 1);
      const currentPage = Math.min(requestedPage, totalPages);
      const startIndex = (currentPage - 1) * itemsPerPage;
      const endIndex = startIndex + itemsPerPage;

      cards.forEach((card, index) => {
        const isVisible = index >= startIndex && index < endIndex;
        card.hidden = !isVisible;
        card.setAttribute('aria-hidden', String(!isVisible));
      });

      renderPagination(section, pagination, currentPage, totalPages);
    };

    const initSection = (section) => {
      if (section.dataset.blogIndexInitialized === 'true') return;
      section.dataset.blogIndexInitialized = 'true';

      const grid = section.querySelector('[data-blog-index-grid]');
      const pagination = section.querySelector('[data-blog-index-pagination]');
      if (!grid || !pagination) return;

      const cards = Array.from(grid.querySelectorAll('[data-blog-index-card]'));
      if (cards.length === 0) return;

      cards.sort((left, right) => {
        return Number(right.dataset.publishedAt || 0) - Number(left.dataset.publishedAt || 0);
      });
      cards.forEach((card) => grid.appendChild(card));
      renderArticles(section, grid, pagination, cards);
    };

    document.querySelectorAll('[data-blog-index]').forEach(initSection);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-gallery"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const sectionId = '{{ section.id }}';
    const galleryLinks = document.querySelectorAll('[data-gallery="gallery-' + sectionId + '"]');
    const lightbox = document.getElementById('lightbox-' + sectionId);
    const lightboxImage = lightbox?.querySelector('.image-gallery-lightbox__image');
    const lightboxCaption = lightbox?.querySelector('.image-gallery-lightbox__caption');
    const closeBtn = lightbox?.querySelector('.image-gallery-lightbox__close');
    const prevBtn = lightbox?.querySelector('.image-gallery-lightbox__prev');
    const nextBtn = lightbox?.querySelector('.image-gallery-lightbox__next');
    
    let currentIndex = 0;
    const images = Array.from(galleryLinks);

    function openLightbox(index) {
      if (!lightbox || !lightboxImage) return;
      
      currentIndex = index;
      const link = images[currentIndex];
      
      lightboxImage.src = link.href;
      lightboxImage.alt = link.querySelector('img')?.alt || '';
      
      if (lightboxCaption) {
        const caption = link.dataset.caption;
        lightboxCaption.textContent = caption || '';
        lightboxCaption.style.display = caption ? 'block' : 'none';
      }
      
      lightbox.style.display = 'flex';
      document.body.style.overflow = 'hidden';
    }

    function closeLightbox() {
      if (!lightbox) return;
      lightbox.style.display = 'none';
      document.body.style.overflow = '';
    }

    function showPrev() {
      currentIndex = (currentIndex - 1 + images.length) % images.length;
      openLightbox(currentIndex);
    }

    function showNext() {
      currentIndex = (currentIndex + 1) % images.length;
      openLightbox(currentIndex);
    }

    galleryLinks.forEach((link, index) => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        openLightbox(index);
      });
    });

    closeBtn?.addEventListener('click', closeLightbox);
    prevBtn?.addEventListener('click', showPrev);
    nextBtn?.addEventListener('click', showNext);

    lightbox?.addEventListener('click', (e) => {
      if (e.target === lightbox) {
        closeLightbox();
      }
    });

    // Keyboard navigation
    const handleKeydown = (e) => {
      if (lightbox?.style.display === 'flex') {
        if (e.key === 'Escape') closeLightbox();
        if (e.key === 'ArrowLeft') showPrev();
        if (e.key === 'ArrowRight') showNext();
      }
    };
    
    document.addEventListener('keydown', handleKeydown);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sleepy-sloth-four-image-cta"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initTriggers() {
      document.querySelectorAll('[data-newsletter-popup-trigger]').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          var popupId = 'newsletter-popup-' + btn.dataset.newsletterPopupTrigger;
          var popup = document.getElementById(popupId);
          if (popup) {
            popup.hidden = false;
            document.body.style.overflow = 'hidden';
            var firstInput = popup.querySelector('input');
            if (firstInput) firstInput.focus();
          }
        });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initTriggers);
    } else {
      initTriggers();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sleepy-sloth-new-in-dynamic"] && !Shopify.designMode) return;
  try {
    
  function initNewInScroller(scroller) {
    if (scroller.dataset.newInScrollerReady === 'true') return;

    var track = scroller.querySelector('[data-new-in-track]');
    var prevButton = scroller.querySelector('[data-new-in-prev]');
    var nextButton = scroller.querySelector('[data-new-in-next]');

    if (!track || !prevButton || !nextButton) return;

    scroller.dataset.newInScrollerReady = 'true';

    function getScrollAmount() {
      var item = track.querySelector('.ss-new-in-scroller__item');
      var gap = parseFloat(window.getComputedStyle(track).gap || '0');

      if (!item) return track.clientWidth;

      return item.getBoundingClientRect().width + gap;
    }

    function updateControls() {
      var maxScroll = track.scrollWidth - track.clientWidth;
      var canScroll = maxScroll > 1;

      prevButton.disabled = !canScroll || track.scrollLeft <= 1;
      nextButton.disabled = !canScroll || track.scrollLeft >= maxScroll - 1;
    }

    prevButton.addEventListener('click', function() {
      track.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
    });

    nextButton.addEventListener('click', function() {
      track.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
    });

    track.addEventListener('scroll', updateControls, { passive: true });
    window.addEventListener('resize', updateControls);
    updateControls();
    window.setTimeout(updateControls, 250);
  }

  function initAllNewInScrollers() {
    document.querySelectorAll('.ss-new-in-scroller').forEach(initNewInScroller);
  }

  document.addEventListener('DOMContentLoaded', initAllNewInScrollers);
  document.addEventListener('shopify:section:load', initAllNewInScrollers);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sleepy-sloth-shop-range-dynamic"] && !Shopify.designMode) return;
  try {
    
  function initShopRangeScroller(scroller) {
    if (scroller.dataset.shopRangeScrollerReady === 'true') return;

    var track = scroller.querySelector('[data-shop-range-track]');
    var prevButton = scroller.querySelector('[data-shop-range-prev]');
    var nextButton = scroller.querySelector('[data-shop-range-next]');

    if (!track || !prevButton || !nextButton) return;

    scroller.dataset.shopRangeScrollerReady = 'true';

    function getScrollAmount() {
      var item = track.querySelector('.ss-shop-range-scroller__item');
      var gap = parseFloat(window.getComputedStyle(track).gap || '0');

      if (!item) return track.clientWidth;

      return item.getBoundingClientRect().width + gap;
    }

    function updateControls() {
      var maxScroll = track.scrollWidth - track.clientWidth;
      var canScroll = maxScroll > 1;

      prevButton.disabled = !canScroll || track.scrollLeft <= 1;
      nextButton.disabled = !canScroll || track.scrollLeft >= maxScroll - 1;
    }

    prevButton.addEventListener('click', function() {
      track.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
    });

    nextButton.addEventListener('click', function() {
      track.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
    });

    track.addEventListener('scroll', updateControls, { passive: true });
    window.addEventListener('resize', updateControls);
    updateControls();
    window.setTimeout(updateControls, 250);
  }

  function initAllShopRangeScrollers() {
    document.querySelectorAll('.ss-shop-range-scroller').forEach(initShopRangeScroller);
  }

  document.addEventListener('DOMContentLoaded', initAllShopRangeScrollers);
  document.addEventListener('shopify:section:load', initAllShopRangeScrollers);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss-blogs-section"] && !Shopify.designMode) return;
  try {
    
  // Mobile carousel pagination indicator
  document.addEventListener('DOMContentLoaded', function() {
    const blogsSection = document.querySelector('[data-section-id="{{ section.id }}"]');
    if (!blogsSection) return;

    const grid = blogsSection.querySelector('.ss-blogs-grid');
    const dots = blogsSection.querySelectorAll('.ss-blogs-pagination__dot');
    
    if (!grid || dots.length === 0) return;

    // Update active dot based on scroll position
    function updateActiveDot() {
      const scrollLeft = grid.scrollLeft;
      const cardWidth = grid.querySelector('.ss-blog-card')?.offsetWidth || 0;
      const gap = 16; // Match CSS gap
      const itemWidth = cardWidth + gap;
      
      let activeIndex = Math.round(scrollLeft / itemWidth);
      activeIndex = Math.max(0, Math.min(activeIndex, dots.length - 1));
      
      dots.forEach((dot, index) => {
        if (index === activeIndex) {
          dot.classList.add('ss-blogs-pagination__dot--active');
        } else {
          dot.classList.remove('ss-blogs-pagination__dot--active');
        }
      });
    }

    // Use Intersection Observer for better performance
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              const card = entry.target;
              const index = Array.from(grid.children).indexOf(card);
              dots.forEach((dot, dotIndex) => {
                if (dotIndex === index) {
                  dot.classList.add('ss-blogs-pagination__dot--active');
                } else {
                  dot.classList.remove('ss-blogs-pagination__dot--active');
                }
              });
            }
          });
        },
        {
          root: grid,
          threshold: 0.5,
        }
      );

      grid.querySelectorAll('.ss-blog-card').forEach((card) => {
        observer.observe(card);
      });
    } else {
      // Fallback for older browsers
      grid.addEventListener('scroll', updateActiveDot, { passive: true });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.video-section__play-button').forEach(button => {
    button.addEventListener('click', () => {
      const cover = button.closest('.video-section__cover');
      if (cover) {
        // Fade out cover
        cover.style.opacity = '0';
        setTimeout(() => {
          cover.style.display = 'none';
        }, 300);
        
        const embed = cover.previousElementSibling;
        const iframe = embed?.querySelector('iframe');
        if (iframe && embed) {
          const videoType = embed.getAttribute('data-video-type');
          const src = iframe.src;
          
          // Enable autoplay based on video type
          if (videoType === 'youtube') {
            // Check if autoplay is already enabled
            if (/[?&]autoplay=0(&|$)/.test(src)) {
              iframe.src = src.replace(/([?&])autoplay=0(&|$)/, '$1autoplay=1$2');
            } else if (!/[?&]autoplay=/.test(src)) {
              iframe.src = src + (src.includes('?') ? '&' : '?') + 'autoplay=1&mute=1';
            }
          } else if (videoType === 'vimeo') {
            let newSrc = src;
            // Handle autoplay parameter
            if (/[?&]autoplay=0(&|$)/.test(newSrc)) {
              newSrc = newSrc.replace(/([?&])autoplay=0(&|$)/, '$1autoplay=1$2');
            } else if (!/[?&]autoplay=/.test(newSrc)) {
              newSrc = newSrc + (newSrc.includes('?') ? '&' : '?') + 'autoplay=1';
            }
            // Handle muted parameter
            if (/[?&]muted=0(&|$)/.test(newSrc)) {
              newSrc = newSrc.replace(/([?&])muted=0(&|$)/, '$1muted=1$2');
            } else if (!/[?&]muted=/.test(newSrc)) {
              newSrc = newSrc + '&muted=1';
            }
            iframe.src = newSrc;
          }
        }
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
